import messages from './tag-messages.js';
export default [
    {tag: 'class3', intlLabel: messages.class3},
    {tag: 'class4', intlLabel: messages.class4},
    {tag: 'class5', intlLabel: messages.class5},
    {tag: 'class6', intlLabel: messages.class6},
    {tag: 'class7', intlLabel: messages.class7},
    {tag: 'class8', intlLabel: messages.class8},
    {tag: 'class9', intlLabel: messages.class9}
    // {tag: 'class10', intlLabel: messages.class10}
];
